import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { QuillModule } from 'ngx-quill';
import { AuthModule } from './auth/auth.module';

@NgModule({
  imports: [CommonModule, HttpClientModule, QuillModule.forRoot(), AuthModule],
  exports: [CommonModule, HttpClientModule],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule has already been loaded. You should only import Core modules in the AppModule');
    }
  }
}
